"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const AudioButton_1 = __importDefault(require("../../atoms/AudioButton"));
const ThreeDotButton_1 = require("../../atoms/ThreeDotButton");
const AlternativeNames_1 = require("../../molecules/AlternativeNames");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
function ButtonActionToolbar({ name, alternativeNames, audioFile, onClose, onClickMinimise, isSelectedMinimise, }) {
    const isLower = (0, ui_1.useScreenBreakpoint)(ui_1.sizeMainScreen.tablet);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const minimiseRef = (0, react_1.useRef)(null);
    const onClickAudio = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        const audio = new Audio('https://cdn.3d4medical.com/audio/' + audioFile);
        try {
            yield audio.play();
        }
        catch (error) {
            console.error(error);
        }
    }), [audioFile]);
    const renderThreeDotButton = () => ((0, jsx_runtime_1.jsx)(ThreeDotButton_1.ThreeDotButton, { tooltipContext: (0, jsx_runtime_1.jsx)(AlternativeNames_1.AlternativeNames, { name: name || '', alternativeNames: alternativeNames || [], onClickAudio: audioFile ? onClickAudio : undefined }), tooltipPlace: isLower ? 'top' : 'top-start', tooltipOnForTouchDevice: true, isOpen: isOpen, onClick: () => setIsOpen(!isOpen), "data-e2e": 'ButtonActionToolbar_ThreeDotButton' }));
    const onHhandleMinimiseClick = () => {
        if (onClickMinimise) {
            onClickMinimise();
            requestAnimationFrame(() => {
                if (minimiseRef.current) {
                    minimiseRef.current.focus();
                }
            });
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Toolbar, { "data-e2e": 'ButtonActionToolbar_Toolbar', children: [isLower ? (alternativeNames ? (renderThreeDotButton()) : (audioFile && (0, jsx_runtime_1.jsx)(AudioButton_1.default, { onClick: onClickAudio, "data-e2e": 'ButtonActionToolbar_AudioButton' }))) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [alternativeNames && renderThreeDotButton(), audioFile && (0, jsx_runtime_1.jsx)(AudioButton_1.default, { onClick: onClickAudio, "data-e2e": 'ButtonActionToolbar_AudioButton' })] })), (0, jsx_runtime_1.jsx)(ui_1.Minimise, { ref: minimiseRef, onClick: onHhandleMinimiseClick, isSelected: isSelectedMinimise, "data-e2e": 'ButtonActionToolbar_Minimise' }), isLower && onClose && ((0, jsx_runtime_1.jsx)(ui_1.ToolBarBaseButton, { onClick: onClose, "data-e2e": 'ButtonActionToolbar_ToolBarBaseButton', children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Close, width: 18, height: 18, "data-e2e": 'ButtonActionToolbar_Icon' }) }))] }));
}
exports.default = ButtonActionToolbar;
const Toolbar = styled_components_1.default.div `
  padding: 4px;
  display: flex;
  gap: 8px;
  background-color: inherit;
  width: fit-content;
`;
